import { Component, ElementRef,EventEmitter, HostListener, Input, NgZone, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.css']
})
export class TimePickerComponent implements OnInit {

  @Output() selectedTime = new EventEmitter<string>();
  @Input() lable: string = '';
  @Input() inputselectedTime:any;

  // Generate time slots with intervals of 1.5 hours

   timeControl = new FormControl('',[Validators.required]);
   timeSlots: string[] = this.generateTimeSlots();
   filteredTimeSlots: Observable<string[]>;

  constructor(private elementRef: ElementRef, private ngZone: NgZone) { 
    this.filteredTimeSlots = this.timeControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
  }

  ngOnInit(): void {
  }


  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    if(this.timeSlots.filter((time) => time.toLowerCase().includes(filterValue)).length){
      return this.timeSlots.filter((time) => time.toLowerCase().includes(filterValue));
    }else{
      this.clearInput();
    }
    
  }

    // Function to generate time slots
    private generateTimeSlots(): string[] {
      const startTime = 540; // Start time in minutes
      const endTime = 18.5 * 60; // End time in minutes (24 hours)
      const interval = 30; // Interval in minutes (1.5 hours)

      const timeSlots: string[] = [];
      for (let time = startTime; time < endTime; time += interval) {
        const hours = Math.floor(time / 60);
        const minutes = time % 60;
        const period = hours < 12 ? 'AM' : 'PM';

        // Convert hours to 12-hour format
        const formattedHours = hours % 12 || 12;

        const formattedTime = `${this.pad(formattedHours)}:${this.pad(minutes)} ${period}`;
        timeSlots.push(formattedTime);
      }
      

      return timeSlots;
    }
  
      // Function to pad single-digit numbers with leading zero
      private pad(n: number): string {
        return n < 10 ? `0${n}` : `${n}`;
      }
  
      // Emit selected time when a time slot is clicked
      selectTime(time: string): void {
        const [hours, minutes, period] = time.split(/[:\s]+/);
        let militaryHours = parseInt(hours, 10);
    
        if (period.toLowerCase() === 'pm' && militaryHours !== 12) {
          militaryHours += 12;
        } else if (period.toLowerCase() === 'am' && militaryHours === 12) {
          militaryHours = 0;
        }
    
        const militaryTime = `${this.pad(militaryHours)}:${this.pad(parseInt(minutes, 10))}`;
        
    
        // Emit the converted time
        this.selectedTime.emit(militaryTime);
       
        // Optionally reset the input value
        // this.timeControl.reset();
        // this.selectedTime.emit(time);
      }

    
      clearInput(): void {
        this.timeControl.setValue('');
        this.selectedTime.emit('');
      }

      @HostListener('document:click', ['$event'])
      handleClickOutside(event: Event): void {
        const clickedElement = event.target as HTMLElement;
        const inputElement = this.elementRef.nativeElement.querySelector('input');
    
        if (inputElement && !inputElement.contains(clickedElement)) {
          // Clicked outside the input element
          let filterValue = this.timeControl.value?.toLowerCase();
         
          const matches = this.timeSlots.filter((time) => time.toLowerCase() === filterValue);
        
          if (!matches.length) {
            this.clearInput();
          } 
          // You can trigger your event or perform other actions here
        }
      }

}
